import React, { useCallback, useMemo } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import LoadBookingIcon from "../../../../../../assets/icons/LoadBookingIcon";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";

const LoadBookingAction = React.memo(({ 
  availableToBook, 
  load, 
  carrierId, 
  active, 
  originPoint, 
  actionCallback 
}) => {
  // Memoize disabled calculation
  const isDisabled = useMemo(() => {
    return !availableToBook || (carrierId !== "" && !originPoint?.includes("freight"));
  }, [availableToBook, carrierId, originPoint]);

  // Memoize the click handler
  const handleClick = useCallback(() => {
    if (availableToBook) {
      actionCallback({ 
        action: "load-booking", 
        loadId: load.orderId, 
        carrierId: carrierId 
      });
    }
  }, [availableToBook, actionCallback, load.orderId, carrierId]);

  return (
    <StyledTooltip title="Book Load">
      <Box>
        <InlineIconButton
          onClick={handleClick}
          disabled={isDisabled}
          icon={LoadBookingIcon}
          buttonColor={active ? "white" : "blue"}
        />
      </Box>
    </StyledTooltip>
  );
}, (prevProps, nextProps) => {
  // Custom comparison - return true if props are equal (skip re-render)
  return (
    prevProps.load.orderId === nextProps.load.orderId &&
    prevProps.carrierId === nextProps.carrierId &&
    prevProps.active === nextProps.active &&
    prevProps.availableToBook === nextProps.availableToBook &&
    prevProps.originPoint === nextProps.originPoint &&
    prevProps.actionCallback === nextProps.actionCallback
  );
});

LoadBookingAction.displayName = 'LoadBookingAction';

LoadBookingAction.propTypes = {
  availableToBook: PropTypes.bool.isRequired,
  load: PropTypes.object.isRequired,
  carrierId: PropTypes.string,
  active: PropTypes.bool,
  originPoint: PropTypes.string,
  actionCallback: PropTypes.func.isRequired
};

export default LoadBookingAction;